module.exports = __webpack_public_path__ + "static/img/ban02.61787bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/ban02.jpg
// module id = afQQ
// module chunks = 1